import { Component, OnInit, Input } from '@angular/core';
import {State} from './state';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { StateService } from './stateService';

@Component({
  selector: 'app-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.less']
})
export class StateComponent implements OnInit {
  @Input() state: State
  @Input() txt: String
  states: State[]
  
  private location: Location
  
constructor(private http: HttpClient,  private route: ActivatedRoute,private stateservice: StateService) { }

  ngOnInit() {
   
  }


  save(): void {
   
    this.stateservice.updateState(this.state)
      .subscribe();
  }
  
 getStateById(id: number)
 {
  this.stateservice.getState(id).subscribe(state => this.state = state);
  
 }
  goBack(): void {
    this.location.reload;
  }
}
